import ComponentTable from '../../../Components/Table/Index';
import { Box, IconButton } from '@mui/material';
import { Button } from '../../../../shared/components/button/Button';
import { Add, Search } from '@mui/icons-material';
import { Input } from '../../../../shared/components/Input';
import { InputSelect } from '../../../../shared/components/InputSelect';
import { InputMoney } from '../../../../shared/components/InputMoney';
import { InputDate } from '../../../../shared/components/InputDate';
import useXmlImportPesquisar from '../../../../hooks/useXmlImportPesquisar';
import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { NFViewDialog } from './NFViewDialog';

const FILE_TYPE = [
  {
    value: 1,
    label: 'XML',
  },
  {
    value: 2,
    label: 'TXT',
  }
];

const STATUS = [
  {
    value: 1,
    label: 'Aberto',
  },
  {
    value: 2,
    label: 'Finalizado',
  },
  {
    value: 2,
    label: 'Cancelado',
  },
  {
    value: 2,
    label: 'NF-e Cancelada',
  },
  {
    value: 2,
    label: 'Estornado',
  },
  {
    value: 2,
    label: 'Pré-venda',
  },
  {
    value: 2,
    label: 'Aguardando NF-e',
  },
  {
    value: 2,
    label: 'Aguardando autorização',
  },
  {
    value: 2,
    label: 'Limite Aprovado',
  },
]

export default function ImportacaoXML() {
  const {
    handleSubmit,
    columns,
    rows,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleNavigation,
    loading,
    handleCloseModalView,
    modalPreviewOpen,
    nfPreView,
    handleFinishNf,
    activeTab,
    handleTabChange,
  } = useXmlImportPesquisar();

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <Loader loading={loading}>
        <div className={'pb-2'}>
          <HeaderComponent
            className={'mb-6'}
            text={'IMPORTAÇÃO XML/TXT'}
            ButtonRight={
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Add />}
                title={'Incluir'}
              />
            }
          />
          <form autoComplete='off' onSubmit={handleSubmit} name='pedido-buscar'>
            <div className="'grid grid-cols-9 gap-4 ">
              <InputSelect
                label='Tipo de Arquivo'
                name='TipoArquivo'
                size='small'
                items={FILE_TYPE}
                className={'col-span-6'}
                handleChange={handleChange}
                helperText={
                  touched?.TipoArquivo && errors?.TipoArquivo
                    ? errors?.TipoArquivo
                    : ''
                }
                error={!!(touched?.TipoArquivo && errors?.TipoArquivo)}
                value={values?.file_type ?? ''}
              />

              <InputDate
                label='Data Emissão'
                className='col-span-2'
                name='NfeDataEmissao'
                handleBlur={handleBlur}
                handleChange={handleChange}
                hasError={!!(touched.NfeDataEmissao && errors.NfeDataEmissao)}
                value={values?.NfeDataEmissao ?? ''}
              />
              <Input
                label='Fornecedor'
                name='CliNome'
                className={'col-span-9'}
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={
                  touched?.CliNome && errors?.CliNome ? errors?.CliNome : ''
                }
                hasError={!!(touched?.CliNome && errors?.CliNome)}
                value={values?.CliNome ?? ''}
              />
              <Input
                label='Série'
                name='NfeSerie'
                type={'number'}
                size='small'
                className={'col-span-6'}
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={
                  touched?.NfeSerie && errors?.NfeSerie ? errors?.NfeSerie : ''
                }
                hasError={!!(touched?.NfeSerie && errors?.NfeSerie)}
                value={values?.NfeSerie ?? ''}
              />
              <InputSelect
                label='Status'
                name='NfeStatus'
                size='small'
                items={STATUS}
                className={'col-span-6'}
                handleChange={handleChange}
                helperText={
                  touched?.NfeStatus && errors?.NfeStatus
                    ? errors?.NfeStatus
                    : ''
                }
                error={!!(touched?.NfeStatus && errors?.NfeStatus)}
                value={values?.NfeStatus ?? ''}
              />
              <InputMoney
                label={'Valor'}
                className={'col-span-4'}
                name={'NfeValorTotalNf'}
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={
                  touched?.NfeValorTotalNf && errors?.NfeValorTotalNf
                    ? errors?.NfeValorTotalNf
                    : ''
                }
                hasError={
                  !!(touched?.NfeValorTotalNf && errors?.NfeValorTotalNf)
                }
                value={values?.NfeValorTotalNf ?? ''}
              />
              <IconButton
                size={'large'}
                type={'submit'}
                className={'!col-span-2 !mt-1'}
              >
                <Search style={{ fontSize: '28px' }} />
              </IconButton>
            </div>
          </form>
        </div>
        <ComponentTable columns={columns} rows={rows} tableHeight={'60vh'} />
        <NFViewDialog
          handleTabChange={handleTabChange}
          activeTab={activeTab}
          handleFinishNf={handleFinishNf}
          nfPreView={nfPreView}
          handleCloseModal={handleCloseModalView}
          modalIsOpen={modalPreviewOpen}
        />
      </Loader>
    </Box>
  );
}
